:host {
  display: block;

  .title {
    margin-top: 0;
    margin-bottom: 10px;
  }

  hr {
    border: 0;
    border-bottom: 1px solid var(--av-card-separator-color);
  }

  app-work-hours {
    padding-bottom: 5px;
    margin-right: -10px;
  }

  input {
    @include form-input;
  }

  .form-field {
    @include form-field;
  }

  .form-field-horizontal {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .actions {
    margin-top: 20px;
    text-align: right;
  }
}

.av-calendar-actions {
  display: flex;
  flex-direction: column;

  > av-button {
    margin-bottom: 5px;

    &:last {
      margin-bottom: 0;
    }
  }
}

.av-confirm-actions {
  padding-top: 25px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
}

.av-card-callback {
  // &.av-card-callback-timeslots {
  .av-card-body {
    overflow: auto;
  }
  // }
  .av-card {
    overflow: visible;
    &.av-card-center.av-card-floating {
      right: 50%;
      transform: translateX(50%) scale(1) !important;
    }
  }

  .av-card-body {
    max-height: calc(100vh - 140px);
  }
}

@media screen and (max-width: 480px) {
  .av-card-callback {
    .av-card {
      overflow: auto;
      max-height: calc(100vh - 90px);
    }
  }
}

.av-panel-link {
  background-color: var(--av-card-background-secondary-color);
  color: var(--av-card-color);
  border-radius: var(--av-border-radius-container);
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;
  font-weight: normal;
  padding: 16px;

  img {
    width: 20px;
    height: 20px;
  }
}

.av-textarea-container {
  margin-right: 10px;

  span {
    opacity: 0.7;
  }

  textarea {
    padding: 5px 0;
    background-color: transparent;
    border: 0px;
    font-family: var(--av-font-family);
    width: 100%;
    font-size: 1.1em;
    font-weight: bold;
    color: var(--av-card-color);
    // padding-right: 10px;
  }
}

.form-field-phone {
  display: flex;
  flex-direction: row;
}

.text-muted {
  opacity: 0.5;
}

av-asset {
  width: 100%;
}

.av-direction {
  direction: var(--av-direction);
}
